import { render, staticRenderFns } from "./commissionModify.vue?vue&type=template&id=04028dd8&scoped=true"
import script from "./commissionModify.vue?vue&type=script&lang=js"
export * from "./commissionModify.vue?vue&type=script&lang=js"
import style0 from "./commissionModify.vue?vue&type=style&index=0&id=04028dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04028dd8",
  null
  
)

export default component.exports